package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.calc
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.opacity
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayBetween
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.extendedByBase
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.until
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.RectF
import com.varabyte.kobweb.silk.theme.shapes.clip
import kotlinx.coroutines.delay
import org.example.site_web.aiPalette
import org.example.site_web.components.widgets.AnimatedLogo
import org.example.site_web.toSitePalette
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.CanvasState

val HeroAccContainerStyle = CssStyle {
    base {Modifier
        .width(100.vw)
        .height(25.cssRem)
        .margin(top = 1.em)
    }
    until(Breakpoint.MD){
        Modifier
        .height(18.cssRem)
        .margin(top = 0.em)
    }
}

val HeroAccBoxStyle = CssStyle {
    base {Modifier
        .height(25.cssRem)
        .boxShadow(0.px, 0.px, 10.px, 10.px, aiPalette.mainPalette.darkest)
//        .borderTop {
//            color(aiPalette.mainPalette.darkest.toRgb().copyf(alpha=0.5f))
//            width(0.5.em)
//            style(LineStyle.Solid)
//        }
//        .borderBottom {
//            color(aiPalette.mainPalette.darkest.toRgb().copyf(alpha=0.5f))
//            width(0.5.em)
//            style(LineStyle.Solid)
//        }
        .position(Position.Relative)
        .fillMaxWidth()
        .overflow(Overflow.Clip)
    }
    until(Breakpoint.MD){
        Modifier
            .height(18.cssRem)
    }
}

val HeroAccContainerBackgroundStyle = HeroAccContainerStyle.extendedByBase {
    Modifier.backgroundImage(
        linearGradient(
            180.deg,
            ColorInterpolationMethod.SrgbLinear
        ) {
            add(colorMode.toSitePalette().nearBackground, 0.percent)
            add(colorMode.toSitePalette().farBackground, 15.percent)
            add(colorMode.toSitePalette().farBackground, 75.percent)
            add(colorMode.toSitePalette().nearBackground, 100.percent)
        })
//        linearGradient(Colors.Green, Colors.Red,Colors.Green))
}

fun CanvasState.save(block: () -> Unit) {
    save()
    block()
    restore()
}


@Composable
fun HeroContainer() {
    Box(HeroAccContainerBackgroundStyle.toModifier()) {
            Box(
                HeroAccBoxStyle.toModifier(),
                contentAlignment = Alignment.TopStart
            ) {
                val offset = remember { mutableStateOf(0.0f) }
                val rotationAngle = remember { mutableStateOf(0.0) } //Angle de rotation du logo
                val cycleCounter = remember { mutableStateOf(0) } //Pour gérer les indices d'images
                val imageOpacity = remember { mutableStateOf(0.0f) }
                val mainOpacity = remember { mutableStateOf(0.0f) }
                val comOpacity = remember { mutableStateOf(0.0f) }

                LaunchedEffect(Unit) {
                    val speed = 36.0f  //    Degres/seconds
                    val refreshPeriodMs =  50//ms

                    var angle = 0.0
                    while (true) {

                        if (angle !in 90.0..270.0) {
                            imageOpacity.value = 0.0f
                        } else if (angle > 180.0) {
                            imageOpacity.value = (1.0 - ((angle - 180) / 90.0)).toFloat()
                        } else {
                            imageOpacity.value = ((angle - 90.0) / 90.0).toFloat()
                        }

                        if (angle in 0.0..90.0) {
                            mainOpacity.value = 1.0f
                        } else if (angle > 270.0) {
                            mainOpacity.value = 1.0f - (365.0f-angle.toFloat())/90.0f
                        }
                        else if (angle > 180.0) {
                            mainOpacity.value = 0.0f
                        }
                        else {
                            mainOpacity.value = 1.0f - (angle.toFloat()-90.0f)/90.0f
                        }

                        if (angle in 0.0..45.0) {
                            comOpacity.value = (angle.toFloat()/45.0f)
                        }
                        else if (angle in 45.0..150.0) {
                            comOpacity.value = 1.0f
                        }
                        else if (angle in 150.0..170.0) {
                            comOpacity.value = 1.0f-((angle.toFloat()-150.0f)/(20.0f))
                        }
                        else {
                            comOpacity.value = 0.0f
                        }

                        if (angle in 90.0..270.0) {
                            offset.value = 10.0f*(angle.toFloat()-90.0f)/180.0f
                        }
                        else {
                            offset.value = 0.0f
                        }


                        //Refresh Angle
                        delay(refreshPeriodMs.toLong())
                        val increment = (refreshPeriodMs.toFloat()/1000.0f) * speed
                        if(angle+increment>=360.0f) {
                            angle = (angle+increment-360.0f)
                            cycleCounter.value +=1
                        }
                        else{
                            angle+=increment
                        }
                        rotationAngle.value = angle
                    }
                }
                val posTop = (-0.4f * (offset.value)).em

                val contWidth by StyleVariable(100.vw)
                val imWidth by StyleVariable(960.px)

                console.log(contWidth.value())
                val newi = contWidth.value().to(CSSUnit.px)
                val imgModifier = Modifier
                    .position(Position.Absolute)
                    .opacity(imageOpacity.value)
                    .objectFit(ObjectFit.Fill)

                //Ecran Peu Large
                Img(
                    src = "assets/pics/heropics/S/${(1+(cycleCounter.value%3))}.jpg",
                    attrs = imgModifier
                        .displayUntil(Breakpoint.LG)
                        .width(111.percent)
                        .height(100.percent)
                        .top(0.percent)
                        .left((-11.1f+offset.value*1.11f).percent)
                        .clip(RectF(10-offset.value to 0.0f, 100.0f-offset.value to 100.0f))
                        .objectFit(ObjectFit.Fill)
                        .toAttrs()
                )
                //Ecran Moyen
//                Img(
//                    src = "assets/pics/heropics/M/${(1+(cycleCounter.value%3))}.jpg",
//                    attrs = imgModifier
//                        .displayUntil(Breakpoint.LG)
//                        .displayIfAtLeast(Breakpoint.LG)
//                        .width(111.percent)
//                        .height(166.6.percent)
//                        .top(-33.2.percent)
//                        .left((-11.1f+offset.value*1.11f).percent)
//                        .clip(RectF(10-offset.value to 20.0f, 100.0f-offset.value to 80.0f))
//                        .toAttrs()
//                )
                //Ecran Large
                Img(
                    src = "assets/pics/heropics/L/${(1+(cycleCounter.value%3))}.jpg",
                    attrs = imgModifier
                        .displayIfAtLeast(Breakpoint.LG)
                        .width(111.percent)
                        .height(166.6.percent)
                        .top(-33.2.percent)
                        .left((-11.1f+offset.value*1.11f).percent)
                        .clip(RectF(10-offset.value to 20.0f, 100.0f-offset.value to 80.0f))
                        .toAttrs()
                )
                Box( Modifier
                    //.boxShadow(0.px, 0.px, 10.px, 10.px, aiPalette.mainPalette.darkest)
                    .position(Position.Absolute)
                    .top(37.5.percent)
                    .left(50.percent-2.5.cssRem)
                    .aspectRatio(0.8f)
                    .height(25.percent)) {
                    AnimatedLogo(
                        rotationAngle, Modifier
                            .height(100.percent)
                            .width(100.percent)
                    )
                }
                HeroTextBoxMain(
                    Modifier
                        .position(Position.Absolute)
                        .top(clamp(9.percent,8.vw,1.cssRem))
                        .fontSize(clamp(0.cssRem,5.vw,2.5.cssRem))
                        .fontWeight(FontWeight.Bold)
                        .padding(bottom=2.percent)
                        .color(aiPalette.mainPalette.primary.toRgb().copyf(alpha =mainOpacity.value))
                )

                HeroTextBoxSecond(
                    Modifier
                        .position(Position.Absolute)
                        .left(0.percent)
                        .bottom(clamp(10.percent,8.vw,1.cssRem))
                        .fontWeight(FontWeight.Bold)
                        .color(rgba(255.0,255.0,255.0,comOpacity.value))

                )
            }
    }
}

@Composable
fun HeroTextBoxMain(modifier: Modifier = Modifier) {
        Box(
            modifier
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
                Text("Ne faites pas attendre")
                Br()
                Text("vos ambitions et votre productivité")
            }

        }
}

@Composable
fun HeroTextBoxSecond(modifier: Modifier = Modifier) {
        Box(
            modifier
                .fillMaxWidth()
                .margin(top = 1.em)
                .fontSize(clamp(0.cssRem,4.vw,2.cssRem))
                .fontWeight(FontWeight.Light),
            contentAlignment = Alignment.Center
        ) {
            Span(Modifier.textAlign(TextAlign.Center).toAttrs())
            {
                Text("Nous concrétisons vos idées techniques")
                Br()
                Text("pour faire progresser vos méthodes et vos outils.")
            }
        }
}